import React, { useState } from "react";
import PropTypes from "prop-types";

import Button from "../../../../components/Button/Button.jsx";
import ButtonsGroup from "../../../../components/ButtonsGroup/ButtonsGroup.jsx";

import UModal from "../../../../components/Modals/UModal.jsx";
import WrapperContainer from "../../../../components/WrapperContainer/WrapperContainer.jsx";

import { getFormattedDate } from "../../../../utils/helpers/formatDate.js";
import handleNotify from "../../../../utils/helpers/handleNotify.js";

import { apiSubscribeDocument, apiDownloadDocumentHome } from "../../../../api/methods/document.js";
import SvgIcon from "../../../../components/Icon/SvgIcon.jsx";

import { openDocument } from "../../../../utils/helpers/openDocument.js";
import "./style.scss";

const DocumentItem = ({ isUnsignedDocument, document, contract, getDocuments }) => {
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);

  /**
   * Подписать документ
   *
   * @param {Number} documentId
   */
  const subscribeDocument = async documentId => {
    try {
      await apiSubscribeDocument(contract.contract_id, contract.billing_id, documentId);

      handleNotify("success", null, "Документ подписан");
      setIsOpenModalConfirm(false);
      await getDocuments(contract);
    } catch (error) {
      handleNotify("error", error);
    }
  };

  /**
   * Получить ссылку на документ для просмотра или скачивания
   *
   * @param {Number} documentId
   */
  const downloadDocument = async documentId => {
    try {
      const response = await apiDownloadDocumentHome(
        contract.contract_id,
        contract.billing_id,
        documentId
      );

      openDocument(response.data?.detail?.message);
    } catch (error) {
      handleNotify("error", error);
    }
  };

  const { documentId, name, createDate } = document;

  return (
    <>
      <div className="document text-vgap16">
        <div className="document__self">
          <Button
            className="document__btn-download"
            icon="only"
            paddingOff="all"
            onClick={() => downloadDocument(documentId)}
          >
            <SvgIcon name="document" color="#AAABAD" />
            <SvgIcon name="download" color="#AAABAD" />
          </Button>
          <div className="document__data">
            <div className="document__data-title">{name}</div>
            <div className="document__data-date">от {getFormattedDate(createDate)}</div>
          </div>
        </div>
        {isUnsignedDocument ? (
          <Button color="secondary" size="md" onClick={() => setIsOpenModalConfirm(true)}>
            Подписать
          </Button>
        ) : (
          <Button size="md" className="document__status">
            Подписано
          </Button>
        )}
      </div>

      {isOpenModalConfirm && (
        <UModal
          isOpenModal={isOpenModalConfirm}
          modalTitle="Подтверждение действия"
          closeModal={() => setIsOpenModalConfirm(false)}
        >
          <WrapperContainer gap="24">Вы уверены, что хотите подписать документ?</WrapperContainer>

          <ButtonsGroup>
            <Button
              isStretch
              color="secondary"
              size="xl"
              onClick={() => setIsOpenModalConfirm(false)}
            >
              Отменить
            </Button>
            <Button
              isStretch
              color="primary"
              size="xl"
              onClick={() => subscribeDocument(documentId)}
            >
              Подписать
            </Button>
          </ButtonsGroup>
        </UModal>
      )}
    </>
  );
};

DocumentItem.propTypes = {
  isUnsignedDocument: PropTypes.bool.isRequired,
  document: PropTypes.object.isRequired,
  contract: PropTypes.object.isRequired,
  getDocuments: PropTypes.func,
};

export default DocumentItem;
